// components/PitchDeck/01_TitleHero.jsx
import React from 'react';
import logowhite from '../../assets/logo/logo-white.png'
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function TitleHero() {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-900 via-blue-950 to-[#4285F4] text-white">
            <div className="text-center max-w-5xl mx-auto px-6">
                <div className="flex justify-center mb-8">
                    <div className="p-4 bg-white/10 backdrop-blur-md rounded-2xl border border-white/20 shadow-2xl">
                        <img
                            src={logowhite}
                            onContextMenu={(e) => e.preventDefault()}
                            draggable="false"
                            alt="Arxis Logo"
                            className="h-16 w-auto object-contain"
                        />
                    </div>
                </div>
                <h1 className="text-5xl md:text-7xl font-bold mb-2 tracking-tight">
                    Arxis Accounting
                </h1>
                <h4 className="text-xs mb-4"> &lt; <code> arxistechnologies.com </code> &gt; </h4>
                <p className="text-2xl md:text-4xl font-semibold mb-8 opacity-90">
                    Precision Accounting for Nigerian Businesses — Automated, Compliant, Affordable
                </p>
                <p className="text-xl md:text-2xl max-w-4xl mx-auto opacity-80">
                    From sole proprietors to growing SMEs: We turn everyday business processes into auditable, FIRS-ready financials — so owners focus on growth, not paperwork.
                </p>
                <div className="mt-12">
                    <span className="text-lg font-medium">James Oyewale, Founder • Founded March 2025 • Launched Nov 2025 • First Customer: ₦15M Daily Sales</span>
                </div>
                <div className="mt-16">
                    <button
                        className="group inline-flex items-center gap-2 px-8 py-4 bg-gray-100/10 hover:bg-gray-100/20 border border-gray-300/40 rounded-full text-gray-200 font-medium text-lg transition-all duration-300 backdrop-blur-sm shadow-sm hover:shadow-md hover:scale-105"
                    >
                        <Link to="problem">
                            <ArrowRight
                                className="w-5 h-5 transition-transform group-hover:translate-x-1"
                            />
                        </Link>
                    </button>
                </div>
            </div>
        </div>
    );
}